import { ChangeDetectorRef, Component } from '@angular/core';
import { EtlIngestionService } from '../../services/etl-ingestion/etl-ingestion.service';
import { AppService } from '../../app.service';
import { catchError, finalize, of, tap } from 'rxjs';
import { NotificationSchedulesService } from '../../services/notification-schedules/notification-schedules.service';
import { isArrayWithData } from '../../utilities/array-helpers';
import { getTimeFromDateHHMMSS } from '../../utilities/date-helpers';

@Component({
  selector: 'app-notification-schedules',
  templateUrl: './notification-schedules.component.html',
  styleUrl: './notification-schedules.component.css'
})
export class NotificationSchedulesComponent {
    isSideBarVisible: boolean = false;
    isDeleteModalVisible: boolean = false;
    toDeleteItem:any;
    editedId: number = 0;
    selectedCreditorId:string = '';
    notificationSchedules!: any[]; 

    firstName: string = '';
    lastName: string = '';
    email: string = '';

    dayOptions: any = [
      {
        name: 'SUN',
        value: 'Sunday'
      },
      {
        name: 'MON',
        value: 'Monday'
      },
      {
        name: 'TUE',
        value: 'Tuesday'
      },
      {
        name: 'WED',
        value: 'Wednesday'
      },
      {
        name: 'THU',
        value: 'Thursday'
      },
      {
        name: 'FRI',
        value: 'Friday'
      },
    ];
    selectedDay: any = this.dayOptions[0];
    preferredTime: any;
    startTime: any;
    endTime: any;
    editedSchedule: any;
    isActive: boolean = false;

  public constructor(
    private etlIngestionService: EtlIngestionService, 
    private appService: AppService, 
    private notificationSchedulesService: NotificationSchedulesService,
    private cdr: ChangeDetectorRef) { }

  ngOnInit() {
    this.resetForm();

    const currentSession = this.appService.getCurrentSession()
    console.log('CurrentSession:', currentSession);
  }

  onSelectCreditor(creditorId: string){
    this.notificationSchedules = [];
    this.selectedCreditorId = creditorId;
  }

  search(){
    if(!!this.selectedCreditorId){
      //this.getMockData();  

      this.appService.isShowPageSpinner = true;
      this.notificationSchedulesService.get(this.selectedCreditorId)
          .pipe(
            tap((res: any ) => {
              if(isArrayWithData(res)){
                this.notificationSchedules = res;
              }  
            }),
            catchError(error => {          
              this.appService.openCommonModal('Error','There seems to be an error getting the Notification Schedules.');
              return of(null); 
            }),
            finalize(() => {   
              this.appService.isShowPageSpinner = false;
            })
          ).subscribe();
    }
  }

  getMockData(){
      this.notificationSchedules = [
        {
          notificationScheduleId: 43,
          creditorId: 2,
          day: "Sunday",
          preferredTimeUtc: "00:00:00",
          startTimeUtc: "00:00:00",
          endTimeUtc: "00:00:00",
          isActive: false,
          createdOnUtc: "2024-09-17T15:09:00",
          createdBy: "RavenExport",
          updatedOnUtc: null,
          updatedBy: null,
          deletedOnUtc: null,
          deletedBy: null
        },
        {
          notificationScheduleId: 44,
          creditorId: 2,
          day: "Monday",
          preferredTimeUtc: "14:00:00",
          startTimeUtc: "11:00:00",
          endTimeUtc: "17:00:00",
          isActive: true,
          createdOnUtc: "2024-09-17T15:09:00",
          createdBy: "RavenExport",
          updatedOnUtc: null,
          updatedBy: null,
          deletedOnUtc: null,
          deletedBy: null
        },
        {
          notificationScheduleId: 45,
          creditorId: 2,
          day: "Tuesday",
          preferredTimeUtc: "14:00:00",
          startTimeUtc: "11:00:00",
          endTimeUtc: "17:00:00",
          isActive: true,
          createdOnUtc: "2024-09-17T15:09:00",
          createdBy: "RavenExport",
          updatedOnUtc: null,
          updatedBy: null,
          deletedOnUtc: null,
          deletedBy: null
        },
        {
          notificationScheduleId: 46,
          creditorId: 2,
          day: "Wednesday",
          preferredTimeUtc: "14:00:00",
          startTimeUtc: "11:00:00",
          endTimeUtc: "17:00:00",
          isActive: true,
          createdOnUtc: "2024-09-17T15:09:00",
          createdBy: "RavenExport",
          updatedOnUtc: null,
          updatedBy: null,
          deletedOnUtc: null,
          deletedBy: null
        },
        {
          notificationScheduleId: 47,
          creditorId: 2,
          day: "Thursday",
          preferredTimeUtc: "14:00:00",
          startTimeUtc: "11:00:00",
          endTimeUtc: "17:00:00",
          isActive: true,
          createdOnUtc: "2024-09-17T15:09:00",
          createdBy: "RavenExport",
          updatedOnUtc: null,
          updatedBy: null,
          deletedOnUtc: null,
          deletedBy: null
        },
        {
          notificationScheduleId: 48,
          creditorId: 2,
          day: "Friday",
          preferredTimeUtc: "14:00:00",
          startTimeUtc: "11:00:00",
          endTimeUtc: "17:00:00",
          isActive: true,
          createdOnUtc: "2024-09-17T15:09:00",
          createdBy: "RavenExport",
          updatedOnUtc: null,
          updatedBy: null,
          deletedOnUtc: null,
          deletedBy: null
        },
        {
          notificationScheduleId: 49,
          creditorId: 2,
          day: "Saturday",
          preferredTimeUtc: "14:00:00",
          startTimeUtc: "11:00:00",
          endTimeUtc: "17:00:00",
          isActive: true,
          createdOnUtc: "2024-09-17T15:09:00",
          createdBy: "RavenExport",
          updatedOnUtc: null,
          updatedBy: null,
          deletedOnUtc: null,
          deletedBy: null
        }
      ];
  }

  formatTime(time: string | null): Date | null {
    if (!time || time === '00:00:00') return null;
    return this.getDateWithTime(time);
  }

  
  onOpenSideBar(schedule: any = null){
    if(!!this.selectedCreditorId){      
          this.isSideBarVisible = true;

      setTimeout(() => {

          const svgElement = document.querySelector('.p-dropdown-trigger-icon') as SVGElement | null;
          if (svgElement) {
            svgElement.style.fill = 'white';
            svgElement.style.color = 'white';
          }

          const trigger = document.querySelector('.p-dropdown-trigger') as HTMLElement | null;
          if (trigger) {
            trigger.style.color = 'white';
          }

      },1000)

      if(schedule){
        this.editedSchedule = schedule;
        this.editedId = schedule.notificationScheduleId;
        this.preferredTime = this.getDateWithTime(schedule.preferredTimeUtc);
        this.startTime = this.getDateWithTime(schedule.startTimeUtc);
        this.endTime = this.getDateWithTime(schedule.endTimeUtc);
        this.isActive = schedule.isActive;
        this.selectedDay = this.dayOptions.find((i:any) => i.value === schedule.day);
      }else{
        this.resetForm();
      }
    }else{
      this.appService.showSelectCreditorMessage();
    }
  }

  resetForm = () => {
    const now = new Date();
    this.preferredTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 10, 0, 0);
    this.startTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 10, 0, 0);
    this.endTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 10, 0, 0);
    this.isActive = false;

    this.selectedDay = this.dayOptions[0];
    this.editedId = 0;
    this.editedSchedule = null;
  }

  getDateWithTime = (time: any) => {
    const now = new Date();
    const [hours, minutes, seconds] = time.split(':').map(Number);
    return new Date(now.getFullYear(), now.getMonth(), now.getDate(), hours, minutes, seconds);;
  }


  onSave(){     
    const newPreferredTime =getTimeFromDateHHMMSS(this.preferredTime); 
    const newStartTime = getTimeFromDateHHMMSS(this.startTime);
    const newEndTime = getTimeFromDateHHMMSS(this.endTime);

    this.appService.isShowPageSpinner = true;
    if(!this.editedId && !!this.selectedCreditorId){
      this.notificationSchedulesService.post(
        parseInt(this.selectedCreditorId), 
        this.selectedDay.value, 
        newPreferredTime,
        newStartTime,
        newEndTime,
        this.isActive)
        .pipe(
        tap((res: any ) => {      
                
          setTimeout(() => {  
            this.appService.commonModalHeader = 'Success';
            this.appService.commonModalMsg = 'Notification Schedule has been successfully created.';
            this.isSideBarVisible = false;
            this.appService.isCommonModalVisible = true;  
            this.appService.isShowPageSpinner = false;
            this.search();
            },2000)

        }),
        catchError(error => {
          this.appService.commonModalHeader = 'Error';
          this.appService.commonModalMsg = 'There seems to be an error creating the Notification Schedule.';
          this.appService.isCommonModalVisible = true;
          this.appService.isShowPageSpinner = false;
          return of(null); 
        }),
        finalize(() => {
                  
        })
      ).subscribe();
    }else{
      this.notificationSchedulesService.put(
        this.editedId,
        parseInt(this.selectedCreditorId), 
        this.selectedDay.value, 
        newPreferredTime,
        newStartTime,
        newEndTime,
        this.isActive,
        this.editedSchedule.createdBy,
        this.editedSchedule.createdOnUtc,        
      )
      .pipe(
        tap(() => {

          //@refresh is not working so will refresh page in the meantime
          // const newNotificationSchedules = this.notificationSchedules.map((item: any) => {
          //   if (item.NotificationScheduleId === this.editedId) {
          //     item.day = this.selectedDay.value,
          //     item.preferredTimeUtc = newPreferredTime
          //     item.startTimeUtc = newStartTime,
          //     item.endTimeUtc = newEndTime;
          //     item.isActive = this.isActive;
          //   }
          //   return item;
          // });
          // this.notificationSchedules = newNotificationSchedules;
          // this.cdr.detectChanges();

          setTimeout(() => {  
            this.appService.commonModalHeader = 'Success';
            this.appService.commonModalMsg = 'Notification Schedule has been successfully updated.';
            this.appService.isCommonModalVisible = true;
            this.isSideBarVisible = false;            
            this.appService.isShowPageSpinner = false;
            this.search();
            },1000)
        }),
        catchError(error => {
          this.appService.commonModalHeader = 'Error';
          this.appService.commonModalMsg = 'There seems to be an error saving the Notification Schedule.';
          this.appService.isCommonModalVisible = true;
          this.appService.isShowPageSpinner = false;
          return of(null); 
        }),
        finalize(() => {
     
        })
      )
      .subscribe();
    }       
  }
}

